<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>视频管理</el-breadcrumb-item>
      <el-breadcrumb-item>视频列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card class="conentBox">
      <div class="conentRow">
        <div>
          <el-input v-model="searchData.videoName" placeholder="视频名称" clearable />

          <el-select v-model="searchData.videoType" placeholder="全部分类" clearable>
            <el-option
              v-for="item in videoTypeOption"
              :key="item.type"
              :label="item.type"
              :value="item.type"
            ></el-option>
          </el-select>
          <!-- <img class="imgPosi" :src="imgXlb" alt /> -->

          <el-button type="primary" @click="searchFn">查询</el-button>
        </div>

        <div>
          <el-button type="primary" plain @click="videoFn">上传视频</el-button>
        </div>
      </div>
    </el-card>
    <!-- 卡片结束 -->

    <div class="videoBox">
      <div class="videoContent" v-for="v in videoListData" @click="WatchVideo(v)" :key="v.id">
        <div>
          <img :src="v.pictureurl" alt />
        </div>
        <div>
          <div>{{v.videoname}}</div>
          <div>{{v.videokey}}</div>
          <div>{{v.type}}</div>
        </div>
        <!-- <div class="btnType">
          <div>置顶</div>
          <div>前移</div>
          <div>后移</div>
          <div>编辑</div>
          <div>删除</div>
        </div>-->
      </div>
    </div>

    <!-- 分页开始 -->
    <div class="pagination">
      <!-- <el-pagination
        @current-change="handleCurrentChange"
        :current-page="videoListPar.page"
        :page-size="10"
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination> -->
      <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{videoListPar.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <!-- 分页结束 -->

    <!-- 信息上下线弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="信息"
      :visible.sync="s=videoDialogVisible"
      :before-close="videoHandleClose"
      width="32%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="80px" :model="addVideoData">
        <el-form-item label="视频名称:">
          <span class="absPosiE">*</span>
          <el-input v-model="addVideoData.videoName"></el-input>
        </el-form-item>
        <div class="itemDiv itemDivss">
          <el-form-item label="视频文件:">
            <span class="absPosiA">*</span>
            <el-input v-model="addVideoData.videoFile"></el-input>
          </el-form-item>
          <el-upload
              class="upload-demo"
              action="http://xwt.softykt.net/api/jfy/uploadVideo"
              :on-success="handlePreviewVide"
              :limit="limit"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
        </div>
        <div class="itemDiv itemNotes">
          <el-form-item label="封面图:">
            <span class="absPosiB">*</span>
            <!-- <el-input v-model="addVideoData.coverImg " placeholder="选择文件"></el-input> -->
            <el-upload
              class="upload-demo"
              action="http://xwt.softykt.net/api/jfy/uploadVideoImg"
              :on-success="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :limit="limit"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip zhu">注：文件格式png、jpg；大小308*174;封面图每个分类传一张即可</div>
            </el-upload>
          </el-form-item>
          <!-- <el-button class="btnL">开始上传</el-button> -->
        </div>
        <!-- <div class="notesDiv">注：文件格式png、jpg；大小308*174;封面图每个分类传一张即可</div> -->
        <el-form-item label="关键词:">
          <span class="absPosiC">*</span>
          <el-input v-model="addVideoData.keyWord"></el-input>
          <div class="notes">注：关键词可用"/"分割开</div>
        </el-form-item>

        <el-form-item label="分类:">
          <span class="absPosiD">*</span>
          <el-input v-model="addVideoData.type"></el-input>
        </el-form-item>

        <el-form-item class="itemBtnS" style="margin-left:-50px">
          <el-button>清空</el-button>
          <el-button class="btnL" @click="uploadFn()">确认上传</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
    <!-- 视频播放 -->
    <el-dialog :close-on-click-modal="false"
      :title="VideoTitle"
      :visible.sync="VideoFlow"
      :before-close="VideoClose"
      width="32%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <video
          :src="this.videoUrl"
           width="100%"
           controls="controls"
           ref="vueRef"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVideoConfigListPost,
  videoTypeListPost,
  addVideoPost
} from "@/request/video.js";
import { Message } from 'element-ui';

export default {
  components: {},
  data() {
    return {
      VideoTitle:'',
      videoUrl:'',
      VideoFlow:false,
      limit:1,
      videoDialogVisible: false, // 上传视频弹框
      // 获取视频列表传参
      videoListPar: {
        token: "",
        video_name: "",
        type: "",
        page: 1,
        page_size: 10
      },
      videoListData: [], // 视频列表数据
      // 查询
      searchData: {
        videoName: "",
        videoType: ""
      },
      videoTypeOption: [], // 分类下拉值
      total: 1,
      Token: "",
      // 上传视频绑定数据
      addVideoData: {
        videoName: "",
        videoFile: "",
        coverImg: "",
        keyWord: "",
        type: ""
      },
      // 添加视频确认上传传参
      addVideoPar: {
        token: "",
        videoname: "", // 用户名
        videokey: "", // 关键字
        videourl: "", // 视频地址
        type: "", // 分类
        pictureurl: "" // 视频封面地址
      },
      fileList: [
      ],
      imgXl: require("@/images/scenic/sj.png"),
      imgXlb: require("@/images/scenic/sjh.png"),
      options: [
      ],
      value: "",
      radio: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      }
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.videoListPar = {
      token: this.Token,
      video_name: "",
      page: 1,
      page_size: 10
    };
    this.getList(this.videoListPar);
    this.getSelect();
  },
  methods: {
    VideoClose(){
      this.videoUrl = ''
      this.VideoFlow = false
    },
    WatchVideo(v){
      console.log(v)
      this.VideoFlow = true
      this.VideoTitle = v.videoname
      this.videoUrl = v.videourl
    },
    // 视频列表
    getList(data) {
      getVideoConfigListPost(data).then(res => {
        console.log(res);
        this.videoListData = res.data.result.data;
        this.total = res.data.result.total;
      });
    },
    // 查询
    searchFn() {
      this.videoListPar.page = 1;
      this.videoListPar.video_name = this.searchData.videoName;
      this.videoListPar.type = this.searchData.videoType;
      this.getList(this.videoListPar);
    },
    // 获取分类下拉值
    getSelect() {
      let upData = {
        token: this.Token
      };
      videoTypeListPost(upData).then(res => {
        console.log(res);
        this.videoTypeOption = res.data.result;
      });
    },
    // 确认上传
    uploadFn() {
      if( this.addVideoData.videoName==''){
        Message.error('用户名为空')
        return false
      }else if(this.addVideoData.keyWord==''){
        Message.error('关键字为空')
        return false
      }else if(this.addVideoData.videoFile==''){
        Message.error('视频未上传')
        return false
      }else if(this.addVideoData.coverImg==''){
        Message.error('视频封面未上传')
        return false
      }else if(this.addVideoData.type==''){
        Message.error('分类为空')
        return false
      }
      this.addVideoPar = {
        token: this.Token,
        videoname: this.addVideoData.videoName, // 用户名
        videokey: this.addVideoData.keyWord, // 关键字
        videourl: this.addVideoData.videoFile, // 视频地址
        type: this.addVideoData.type, // 分类
        pictureurl: this.addVideoData.coverImg // 视频封面地址
      };
      addVideoPost(this.addVideoPar).then(res => {
        if(res.data.status=='ok'){
          Message.success('添加视频成功')
          this.getList(this.videoListPar)
          this.videoDialogVisible = false
        }
      });
    },
    // 封面图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      this.addVideoData.coverImg = file.result
    },
   
    handlePreviewVide(file){
      this.addVideoData.videoFile = file.result
    },
    // 上传视频
    videoFn() {
      this.videoDialogVisible = true;
    },
    // 上传视频X
    videoHandleClose() {
      this.videoDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.videoListPar.page = val;
      this.getList(this.videoListPar);
    }
  }
};
</script>

<style lang="less" scoped>
.editForm {
  .itemNotes {
    position: relative;
    margin-bottom: 20px;
  }
  .zhu {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #ff4d4f;
  }
  .notesDiv {
    margin-top: 7px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #ff4d4f;
    position: absolute;
    top: 245px;
    left: 100px;
  }
  .notes {
    margin-top: 7px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height */
    color: #ff4d4f;
  }

  .itemDiv {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 300px;
      /deep/.el-input__inner {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        color: #000000;
      }
    }
    .el-button {
      width: 100px;
      height: 40px;
      margin-left: 20px;
      background: #006afa;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      border: none;
      color: #ffffff;
    }
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    /deep/.el-button {
      width: 100px;
      background: #ffffff;
      border: 1px solid #ff4d4f;
      border-radius: 4px;
      box-sizing: border-box;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ff4d4f;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
}

.absPosiA {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #ff4d4f;
}
.absPosiE {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #ff4d4f;
}
.absPosiB {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #ff4d4f;
}
.absPosiC {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #ff4d4f;
}
.absPosiD {
  position: absolute;
  top: 0px;
  left: -51px;
  color: #ff4d4f;
}

.videoBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  border-radius: 0px 0px 4px 4px;
  cursor: pointer;
  justify-content: space-between;
  > div {
    width:30.8rem;
    // min-width: 30rem;
    // margin-right: 20px;
    margin-bottom: 20px;
    position: relative;
    > div:nth-child(1) {
      width: 100%;
      height: 17.4rem;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      height: 14.3rem;
      padding: 20px;
      box-sizing: border-box;
      background: white;
      border-radius: 0px 0px 4px 4px;
      > div:nth-child(1) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        text-align: left;

        color: #000000;
      }
      > div:nth-child(2) {
        margin: 14px 0;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: justify;

        color: #000000;
      }
      > div:nth-child(3) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        text-align: justify;

        color: #666666;
      }
    }

    .btnType {
      width: 300px;
      height: 250px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      display: none;
      // position: absolute;
      // top: 0px;
      // left: 0px;
      div {
        width: 40px;
        height: 20px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #ff4d4f;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.videoContent:hover > .btnType {
  width: 300px;
  height: 250px;
  display: block;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
}
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
.conentBox {
  // height: 78px;
  /deep/.el-card__body {
    padding: 0 0 0 20px;
  }
  margin-top: 17px;
  .conentRow {
    margin: 20px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {

      .el-input {
        width: 240px;
        margin-right: 20px;
        margin-bottom: 20px;
      }
      .el-select {
        width: 260px;
        margin-bottom: 20px;
        margin-right: 20px;
      }
      .el-button {
        width: 100px;
        margin-right: 25px;
        margin-bottom: 20px;
        background: #246deb;
        border-radius: 4px;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #ffffff;
        border: none;
      }
    }
    > div:nth-child(2) {
      display: flex;
      justify-content: flex-end;
      .el-button {
        margin-bottom: 20px;
        width: 100px;
        margin-right: 25px;
        background: #ffffff;
        border: 1px solid #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #246deb;
      }
    }
  }
}
.scenicBtn {
  // width: 596px;
  height: 40px;
  display: flex;
  justify-content: flex-end;
  margin-left: 42px;
  .el-button {
    width: 120px;
    display: flex;
    justify-content: center;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
  }
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 10px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

// 弹框
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
video{
  height: 300px;
}
/deep/ .el-dialog{
  min-width: 440px;
  .itemDiv{
    margin-bottom: 1.5rem;
  }
}
/deep/ .ant-message {
    z-index: 9999 !important;
}
.itemDivss /deep/ .el-upload-list{
  display: none;
}
</style>